import { SCHEDULE_DRAFT, SCHEDULE_SCHEDULED } from 'components/Post/constants.js';
import messages from './messages.js';

function getSuccessMessage(status) {
  switch (status) {
    case SCHEDULE_DRAFT:
      return messages.draftSaved;
    case SCHEDULE_SCHEDULED:
      return messages.itemScheduled;
    default:
      return undefined;
  }
}

export default getSuccessMessage;
